module.exports = __webpack_public_path__ + "static/img/home_3.3e1f88f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/home_3.png
// module id = sGKU
// module chunks = 1